import React, { useState } from 'react';
import { 
  Button, 
  Dialog, 
  IconButton, 
  Slide, 
  TextField, 
  Typography,
  styled,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  DialogActions as MuiDialogActions,
  Rating
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { crearRating } from '../../actions/RatingAction';

// Componentes estilizados
const StyledDialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(2),
  position: 'relative',
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[500],
}));

const StyledDialogContent = styled(MuiDialogContent)(({ theme }) => ({
  padding: theme.spacing(2),
  '& .MuiTextField-root': {
    marginBottom: theme.spacing(2),
  }
}));

const StyledDialogActions = styled(MuiDialogActions)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(1),
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const RatingForm = ({ open, handleClose, propertyId, propertyName, handleDataUpdate }) => {
  const [rating, setRating] = useState({
    id: '0',
    propertyId: propertyId,
    calificacion: 0,
    comentario: ''
  });

  const initialRatingState = {
    id: '0',
    propertyId: propertyId, // Mantenemos el propertyId
    calificacion: 0,
    comentario: ''
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRating(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRatingChange = (event, newValue) => {
    setRating(prev => ({
      ...prev,
      calificacion: newValue,
    }));
  };

  const handleGuardarRating = async () => {
    guardarRating();
    // Resetea el estado a los valores iniciales
    setRating(initialRatingState);
    handleClose();
  };


  const guardarRating = async () => {
    try {
      const response = await crearRating(rating);

      console.log('response graba rating: ', response);

      if (response.status === 201) {
        const newData = {
          promedio: response.data.averageRating,
          cantidadRegistros: response.data.totalRatings,
        };

        console.log('newData rating:', newData);
        handleDataUpdate(newData);
      }
    } catch (error) {
      console.error('Error al guardar el rating:', error);
    }
  }

  return (
    <Dialog 
      onClose={handleClose} 
      aria-labelledby="customized-dialog-title" 
      open={open}
      TransitionComponent={Transition}
      fullWidth
      maxWidth="sm"
    >
      <StyledDialogTitle>
        <Typography variant="h6" style={{ marginRight: '38px' }}>
          Propiedad: {propertyName}
        </Typography>
        <CloseButton aria-label="close" onClick={handleClose}>
          <CloseIcon />
        </CloseButton>
      </StyledDialogTitle>
      
      <StyledDialogContent dividers>
        <Rating
          name="calificacion"
          value={rating.calificacion}
          onChange={handleRatingChange}
          size="large"
          sx={{ mb: 2 }}
        />
        
        <TextField
          label="Comentario"
          variant="outlined"
          multiline
          minRows={3}
          fullWidth
          name="comentario"
          value={rating.comentario}
          onChange={handleChange}
        />
      </StyledDialogContent>
      
      <StyledDialogActions>
        <Button onClick={handleClose} color="primary">
          Cerrar
        </Button>
        <Button 
          onClick={handleGuardarRating} 
          color="primary"
          variant="contained"
        >
          Guardar
        </Button>
      </StyledDialogActions>
    </Dialog>
  );
};

export default RatingForm;